import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  gap: 1.5rem;

  margin: 1.2rem 0;
`;

export default Container;
